import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Documento, AttachmentDto } from '../../models/data.model';
import { CommonService } from '../../services/common.service';
import { EqualtecService } from '../../services/equaltec.service';
import { MimetypeService } from '../../services/mimetype.service';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-equaltec-favorites',
  templateUrl: './EqualtecFavorites.component.html'
})
export class EqualtecFavorites implements OnInit {

  public labelNoRecord: boolean = false;
  public isTabellaPreferitiConUnElemento: boolean = false;
  public isTabellaPreferitiRevisionPending: boolean = false;
  public isExpandedPreferiti: boolean = false;
  public documentsPreferiti: Documento[] = [];
  public doc: Documento[] = [];
  public docApertiPreferiti: number = 0;

  constructor(public translate: TranslateService,
    private equaltecService: EqualtecService,
    private fileServer: CommonService<AttachmentDto>,
    private mimeTypeService: MimetypeService,
    private modalService: ModalService,
    private documentService: CommonService<Documento>,
  ) { }

  ngOnInit(): void {
    this.showResultPreferiti()
  }

  showResultPreferiti = () => {
    this.docApertiPreferiti = 0;
    this.labelNoRecord = false;
    this.isTabellaPreferitiRevisionPending = false;
    this.isExpandedPreferiti = false;
    const url = 'api/rest/GetDocumentiPreferiti';
    const input = {};
    this.documentService.postData(url, input, false).subscribe(result => {
      if (result) {
        let a = this.equaltecService.documents.length
        console.log('this is equaltecService.documents : ', result);
        this.doc = result as Documento[]
        this.doc.forEach(d => {
          d.metadatiDtoList.forEach(p => {
            if (p.key == "StatoDocumento") {
              if (p.value == "RELEASED") {
                this.documentsPreferiti.push(d);
              }
            }
          })
        });
        this.documentsPreferiti.forEach(d => {
          d.metadatiDtoViewList = d.metadatiDtoShortList;
          d.apriDettaglio = "Open detail";
          if (d.isNewRevisionPending) {
            this.isTabellaPreferitiRevisionPending = true;
          }
        });
        this.labelNoRecord = true;
      }
    })
  }

  documentDetail = (apridettaglio: string, codice: string, tipodocumento: string, revisione: string, processOGuideline: string) => {
    if (apridettaglio == "Open detail") {
      this.openDocumentDetail(codice, tipodocumento, revisione, processOGuideline);
    } else {
      this.closeDocumentDetail(codice, tipodocumento, revisione, processOGuideline);
    }
  }

  openDocumentDetail = (codice: string, tipodocumento: string, revisione: string, tipoDiTabella: string) => {
    switch (tipoDiTabella) {
      case "preferiti": {
        this.docApertiPreferiti++;
        let documentiAperti = 0;
        this.isExpandedPreferiti = true;
        this.documentsPreferiti.forEach(doc => {
          if (doc.isNewRevisionPending) {
            this.isTabellaPreferitiRevisionPending = true;
          }
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.metadatiDtoViewList = doc.metadatiDtoList;
            if (this.documentsPreferiti.length > 1) {
              const y = { key: '', value: '' }
              doc.metadatiDtoViewList.splice(3, 0, y);
              doc.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaPreferitiRevisionPending) {
                doc.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaPreferitiConUnElemento = true;
            }
            doc.apriDettaglio = "Close detail";
          }
        })
        this.documentsPreferiti.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiAperti++;
        })
        if (documentiAperti == this.documentsPreferiti.length && this.documentsPreferiti.length > 1) {
          this.isTabellaPreferitiConUnElemento = true;
          this.documentsPreferiti.forEach(doc => {
            const spl = this.isTabellaPreferitiRevisionPending ? 3 : 2;
            doc.metadatiDtoViewList.splice(3, spl);
          })
        }
        break;
      }
      /* Evolutive maggio 2023: nei documenti collegati inseriamo tutti i metadati come il documento padre (anche la colonna revisionPending), più lo stato, il processo e sottoprocesso. */
      default: {
        break;
      }
    }
  }

  closeDocumentDetail = (codice: string, tipodocumento: string, revisione: string, tipoDiTabella: string) => {
    switch (tipoDiTabella) {
      case "preferiti": {
        let documentiApertiFull = 0;
        this.documentsPreferiti.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiApertiFull++;
        })
        if (documentiApertiFull == this.documentsPreferiti.length && this.documentsPreferiti.length > 1) {
          this.isTabellaPreferitiConUnElemento = false;
          this.documentsPreferiti.forEach(doc => {
            const y = { key: '', value: '' }
            doc.metadatiDtoViewList.splice(3, 0, y);
            doc.metadatiDtoViewList.splice(4, 0, y);
            if (this.isTabellaPreferitiRevisionPending) {
              doc.metadatiDtoViewList.splice(5, 0, y);
            }
          })
        }
        this.docApertiPreferiti--;
        this.documentsPreferiti.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            if (this.documentsPreferiti.length > 1) {
              const spl = this.isTabellaPreferitiRevisionPending ? 3 : 2;
              doc.metadatiDtoViewList.splice(3, spl);
            }
            doc.metadatiDtoViewList = doc.metadatiDtoShortList;
            doc.apriDettaglio = "Open detail";
          }
        })
        if (this.docApertiPreferiti == 0) {
          this.isExpandedPreferiti = false;
        }
        break;
      }
      /* Evolutive maggio 2023: nei documenti collegati inseriamo tutti i metadati come il documento padre (anche la colonna revisionPending), più lo stato, il processo e sottoprocesso. */
      default: {
        break;
      }
    }
  }

  tabMenuAllegato = (doc: Documento) => {
    doc.ismenuAllegato = !doc.ismenuAllegato;
    const splitAll = doc.allegatoPrimarioDto.nomeFile.split('.');
    doc.allegatoPrimarioDto.estensione = splitAll[splitAll.length - 1];
  }

  tabMenuAllegatoSecondario = (doc: Documento) => {
    this.modalService.open(doc.allegatiSecondariDtoList, doc.idDocumento);
  }

  tabMenuAllegatoSecondarioList = (doc: Documento, attach: AttachmentDto) => {
    doc.allegatiSecondariDtoList.forEach(all => {
      if (all.nomeFile == attach.nomeFile) {
        all.isTabOpened = !all.isTabOpened;
      } else {
        all.isTabVisualizated = !all.isTabVisualizated;
      }
    })
  }

  getArcadocAttach(item: AttachmentDto, iddocumento: number, download: boolean) {
    const url = 'api/rest/GetAttachment';
    const params = {
      params: {
        idAllegato: item.idAllegato,
        idDocument: iddocumento,
        fileName: item.nomeFile,
        download: download
      }
    };
    this.fileServer.getData(url, params, false).toPromise()
      .then(res => {
        const attachment: AttachmentDto = res as AttachmentDto;
        const fileName = attachment.nomeFile;
        const ext = fileName.split('.').pop() || '';
        const downloadLink = document.createElement("a");
        this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext))
          .then(b => {
            const blob: Blob = b as Blob;
            const url = URL.createObjectURL(blob);
            if (download) {
              downloadLink.href = url;
              downloadLink.download = fileName;
              downloadLink.click();
            } else {
              window.open(url, '_blank')
            }
          })
      });
  }

  dataURIToBlob = (dataURI: any, mimeString: string) => {
    return new Promise(resolve => {
      const binStr = atob(dataURI),
        len = binStr.length,
        arr = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      const result = new Blob([arr], {
        type: mimeString
      });
      resolve(result)
    })
  }

}




